import { useEffect, useRef } from 'react'

declare global {
    interface Window {
        Tally?: { loadEmbeds: () => void }
    }
}

const TALLY_SCRIPT_SRC = 'https://tally.so/widgets/embed.js'

type Props = {
    src: string
    title: string
    height?: number
    width?: number
}

const TallyEmbed: React.FC<Props> = ({ src, title, width = 800, height = 600 }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null)

    useEffect(() => {
        const loadEmbeds = () => window.Tally?.loadEmbeds()

        if (window.Tally) {
            loadEmbeds()
            return
        }

        const existing = document.querySelector(`script[src="${TALLY_SCRIPT_SRC}"]`)
        if (existing) {
            existing.addEventListener('load', loadEmbeds)
            return () => existing.removeEventListener('load', loadEmbeds)
        }

        const script = document.createElement('script')
        script.src = TALLY_SCRIPT_SRC
        script.onload = loadEmbeds
        script.onerror = loadEmbeds
        document.body.appendChild(script)
    }, [])

    return (
        <iframe
            ref={iframeRef}
            data-tally-src={src}
            width={width}
            height={height}
            style={{ border: 'none', backgroundColor: "#FFF", overflowY: "scroll", borderRadius: 10 }}
            title={title}
        />
    )
}

export default TallyEmbed
